<template>
  <div>
    <PageTitle :route="$route">
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <TestSettingsList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import TestSettingsList from '@/components/settings/TestSettingsList'

  export default {
    name: 'TestSettings',
    components: {
      PageTitle,
      PageRowWrapper,
      TestSettingsList
    }
  }
</script>
